// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillSelected, neutralForegroundHint, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const avatarSize = "48px";
const borderColor = "rgba(0, 0, 0, 0.09)";

export const ProfileUsersStyles = (config: DesignSystem) => ({
    profileUsersContainer: {
        padding: "0",
        margin: "0",

        "& .cwt-profile-user": {
            display: "flex",
            "align-items": "center",
            "justify-content": "flex-start",
            padding: "23px 15px",
            "border-bottom": "1px solid ",
            "border-color": neutralFillSelected,

            "& .cwt-avatar": {
                height: avatarSize,
                "min-width": avatarSize,
                "max-width": avatarSize,
                margin: "0 12px"
            },

            "& .cwt-user-info": {
                margin: "0 12px 0",

                "& .cwt-name": {
                    color: neutralForegroundRest,
                    "font-size": "18px",
                    "font-weight": "600"
                },

                "& .cwt-stat": {
                    display: "inline-flex",
                    "margin-top": "6px",
                    "font-size": "13px",
                    color: neutralForegroundHint,

                    "&:before": {
                        display: "inline-block",
                        content: "'|'",
                        margin: "-1px 7.5px 0"
                    },

                    "&:first-child:before": {
                        content: "none"
                    }
                }
            },

            "& .cwt-end": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "auto"
            }
        },

        "& > *:last-child": {
            width: "100px",
            height: "1px",
            opacity: 0
        }

    },

    profileEmptyMessageContainer: {
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
        "justify-content": "center",
        "margin-top": "110px",

        "& .cwt-profile-empty-message": {
            "font-size": "24px",
            color: neutralForegroundHint
        },
        "& .cwt-profile-empty-icon": {
            "margin-bottom": "24px",
            fill: "currentColor",

            "& .cwt-icon-vector": {
                width: "55px",
                height: "55px"
            }
        }
    }
});